import { render, staticRenderFns } from "./CatalogProductSettingClaims.vue?vue&type=template&id=31e469e1&scoped=true&"
import script from "./CatalogProductSettingClaims.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSettingClaims.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductSettingClaims.vue?vue&type=style&index=0&id=31e469e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e469e1",
  null
  
)

export default component.exports